module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('headers', [_c('div', {
    staticClass: "header-main"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("partner.header.h1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("partner.header.p")))])])]), _vm._v(" "), _c('section', {
    staticClass: "main container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("partner.main.q1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("partner.main.a1")))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/qzVWMPj2XdrTm4JL1I-EE0ba4N4%3D",
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t("partner.main.q2")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("partner.main.a2")))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/DSwG-rDc80GCCIlKpf3YLig2mLs%3D",
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t("partner.main.requirement.title")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("partner.main.requirement.dlt")))]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("partner.main.requirement.dl")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("partner.main.requirement.bdt")))]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("partner.main.requirement.bd")))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("partner.main.requirement.phone")))])]), _vm._v(" "), _c('footers')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15154c8a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/pages/partner.vue
// module id = 42
// module chunks = 0